

































import {
  defineComponent,
  onMounted,
  useFetch,
  ref,
  watch,
} from "@nuxtjs/composition-api";
import { useSearchProducts } from "~/composables";
import { useSlickOptions } from "~/stores/extensionApi";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";
import CategoryProductCard from "~/modules/catalog/category/components/views/CategoryProductCard.vue";
import { useAddToCart } from "~/helpers/cart/addToCart";
import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
SwiperCore.use([Navigation, Pagination]);

export default defineComponent({
  name: "CategoryProductSlide",
  components: {
    SkeletonLoader,
    ProductLoadItem,
    CategoryProductCard,
    Swiper,
    SwiperSlide,
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    classItem: {
      type: String,
      default: "",
    },
    classItemParent: {
      type: String,
      default: "block-product__items",
    },

    OptionItem: {
      type: Object,
      default: {},
    },
    sizeGuide: {
      type: String,
      default: null,
    },
    qty_product_display: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const slickOptions = useSlickOptions();
    const { fetchProducts, loading: loadingProduct } = useSearchProducts();
    const { addItemToCart } = useAddToCart();

    const products = ref([]);
    const loading = ref(false);

    const fetch = async () => {
      loading.value = true;
      const itemsPerPage =
        props.qty_product_display || 8
      
      const siguideIds = props.sizeGuide
        ? props.sizeGuide.split(",")
        : [];

      const params = {
        ids: [String(props.categoryId)],
        pageSize: itemsPerPage,
        filters: {
          sizeGuideIds: siguideIds,
        },
      };
      const { data } = await fetchProducts(params);

      products.value = data || [];
      loading.value = false;
    };

    onMounted(async () => {
      await fetch();
    });

    watch(
      () => props.sizeGuide, 
      async () => {
        await fetch();
      }
    );

    return {
      slickOptions,
      products,
      loading,
      loadingProduct,
      addItemToCart,
    };
  },
});
